import React from "react";
import PropTypes from "prop-types";
import { Box, Snackbar, Alert, IconButton, Typography } from "@mui/material";
import WavingHand from "@mui/icons-material/WavingHandOutlined";
import Slide from "@mui/material/Slide";

const WelcomeSnackbar = ({ open, onClose, userName }) => {
  return (
    <Snackbar
      autoHideDuration={3000}
      open={open}
      TransitionComponent={Slide}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      onClose={onClose}
    >
      <Alert
        icon={false}
        variant="filled"
        sx={{ width: "100%", backgroundColor: "#FF7322" }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body2">Bem vindo, {userName}!</Typography>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <WavingHand />
          </IconButton>
        </Box>
      </Alert>
    </Snackbar>
  );
};

WelcomeSnackbar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  userName: PropTypes.string,
};

export default WelcomeSnackbar;
